// remates-1-3-0b (P2, #513): el puntero principal es un dedo (telefono o tableta, tambien la
// web en el telefono). Decide "Haz tap" contra "Haz clic" y el alto del boton "Procesar".
// Vive en su propio archivo, y no en useEsAncho.js, a proposito: el candado de
// appstoreBilingue.tanda27 prohibe que el Panel importe el gate de ancho/alto (ese gate vive
// en el componente AppStoreBloque, no en sus anfitriones); este es OTRO gate, el del puntero.
import { useMedia } from './useEsAncho';

export const CONSULTA_TACTIL = '(pointer: coarse)';

export function useEsTactil() {
  return useMedia(CONSULTA_TACTIL, false);
}
